<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
        <div class="modal-content">
            <div class="box">
                <slot name="header"></slot>
                <slot name="body"></slot>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import ModalMixin from '../../mixins/ModalMixin';

export default {
    name:'app-modal',
    mixins: [ModalMixin],
    data() {
        return {
            //
        };
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },
    },
};
</script>

<style>
.modal {
    z-index: 1024 !important;
}
button.button {
    margin-right: 30px;
}

</style>


// WEBPACK FOOTER //
// src/components/layout/Modal.vue